import React from 'react';
import { Skeleton } from '@mantine/core';
import styles from './notification-skeleton.module.scss';

const NotificationSkeleton = ({ count = 5 }) => {
  return (
    <div className={styles.skeleton_wrapper}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.notification_item}>
          <div className={styles.avatar_section}>
            <Skeleton circle height={40} width={40} />
          </div>
          <div className={styles.content_section}>
            <Skeleton height={14} width="60%" radius="xl" mb={8} />
            <Skeleton height={12} width="85%" radius="xl" mb={6} />
            <Skeleton height={10} width="40%" radius="xl" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationSkeleton;